<nav class="breadcrumb bg-white">
    <ng-template ngFor let-i="index" let-c="count" let-breadCrumbElement [ngForOf]="elements">
        <a *ngIf="i < c-1" class="breadcrumb-item" href="{{breadCrumbElement.url}}" i18n>{{breadCrumbElement.title}}</a>
        <span *ngIf="i === c-1" class="breadcrumb-item active" i18n>{{breadCrumbElement.title}}</span>
    </ng-template>
</nav>
